module.exports = __webpack_public_path__ + "img/selected6-min.d6537c23.png";